export default __webpack_public_path__ + "static/media/icon-email.c805819c.png";